class QueuesServiceClass {

    public socket: any;
    private namespace: string;
    constructor(_socket, _namespace) {
        this.socket = _socket;
        this.namespace = _namespace;
    }

    getQueuesPageService(query: string,projection:any, top: number, skip: number, orderby, reverse: boolean, collectionname: string,
        isMongoQuery: boolean = false) {
        return new Promise<any[]>((resolve, reject) => {
            if (!this.socket || !this.socket.connected) {
                return reject("IO.Socket not connected to /" + this.namespace);
            }
            try {
                this.socket.emit("GET_Queues_PAGE", query,projection, top, skip, orderby, reverse, collectionname, isMongoQuery,
                    (err, result) => {
                        if (err) {
                            return reject(err);
                        }
                        resolve(result);
                    }
                );
            } catch (err) {
                reject(err);
            }
        });
    }    
    addQueueService(item: any, collectionname: string) {
        return new Promise<any>((resolve, reject) => {
            if (!this.socket || !this.socket.connected) {
                return reject('IO.Socket not connected to /' + this.namespace);
            };
            try {
                this.socket.emit('ADD_QUEUE', item, collectionname, function (err, result) {
                    if (err) { return reject(err); }
                    resolve(result);
                });

            } catch (err) {
                reject(err);
            }
        });
    }
    updateQueueService(item: any, collectionname: string) {
        return new Promise<any>((resolve, reject) => {
            if (!this.socket || !this.socket.connected) {
                return reject('IO.Socket not connected to /' + this.namespace);
            };
            try {
                this.socket.emit('UPDATE_QUEUE', item, collectionname, function (err, result) {
                    if (err) { return reject(err); }
                    resolve(result);
                });

            } catch (err) {
                reject(err);
            }
        });
    }
    deletQueueService(id: string) {
        return new Promise<any>((resolve, reject) => {
            if (!this.socket || !this.socket.connected) {
                return reject('IO.Socket not connected to /' + this.namespace);
            };
            try {
                this.socket.emit('DELETE_QUEUE', id, function (err) {
                    if (err) { return reject(err); }
                    resolve(`Queue ${id} deleted successfuly`);
                });

            } catch (err) {
                reject(err);
            }
        });
    }
    deletQueueItemService(id: string) {
        return new Promise<any>((resolve, reject) => {
            if (!this.socket || !this.socket.connected) {
                return reject('IO.Socket not connected to /' + this.namespace);
            };
            try {
                this.socket.emit('DELETE_QUEUE_ITEM', id, function (err) {
                    if (err) { return reject(err); }
                    resolve(`Queue item ${id} deleted successfuly`);
                });

            } catch (err) {
                reject(err);
            }
        });
    }
    getQueueItemsIngrogressCount(id: string) {
        return new Promise<any>((resolve, reject) => {
            if (!this.socket || !this.socket.connected) {
                return reject('IO.Socket not connected to /' + this.namespace);
            };
            try {
                this.socket.emit('GET_QUEUE_ITEMS_INPROGRERSS', id, 
                (err, result) => {
                    if (err) {
                        return reject(err);
                    }
                    resolve(result.itemsCount);
                }
                
                );

            } catch (err) {
                reject(err);
            }
        });
    }
    getQueueItemsPageService(query: string, top: number, skip: number, orderby, reverse: boolean, collectionname: string,
        isMongoQuery: boolean = false) {
        return new Promise<any[]>((resolve, reject) => {
            if (!this.socket || !this.socket.connected) {
                return reject("IO.Socket not connected to /" + this.namespace);
            }
            try {
                this.socket.emit("GET_QUEUE_ITEMS_PAGE", query, top, skip, orderby, reverse, collectionname, isMongoQuery,
                    (err, result) => {
                        if (err) {
                            return reject(err);
                        }
                        resolve(result);
                    }
                );
            } catch (err) {
                reject(err);
            }
        });
    }    

    


}